import React, { useEffect, useState } from "react";
import { Table, Button, Select, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getStates } from "../features/statecity/statecitySlice";
import {
  getCurriculams,
  resetState,
} from "../features/curriculam/curriculamSlice";
import { getUsers } from "../features/cutomers/customerSlice";
import { UploadOutlined } from "@ant-design/icons";
import { getBrands } from "../features/brand/brandSlice";
import { Link } from "react-router-dom";

const columns = [
  { dataIndex: "key", title: "Sr No", width: 10 },
  { dataIndex: "date", title: "Date", width: 30 },
  { dataIndex: "holiday", title: "Holiday", width: 30 },
  { dataIndex: "unit", title: "Unit", width: 30 },
  { dataIndex: "skills", title: "E/V Skills", width: 30 },
  { dataIndex: "topic", title: "Topic", width: 30 },
  { dataIndex: "subTopic", title: "Sub-Topic", width: 30 },
];

const Curriculam = () => {
  const dispatch = useDispatch();
  const [vcData, setVcData] = useState([]);
  const [form] = Form.useForm();

  const statelistState = useSelector((state) => state.statecity.statelist);
  const vclistState = useSelector((state) => state.customer.customers);
  const classlistState = useSelector((state) => state.brand.brands);
  const curriculams =
    useSelector((state) => state.curriculam.curriculams) || [];

  // Use curriculams as the initial data source and for resetting
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    dispatch(resetState());
    dispatch(getCurriculams());
    dispatch(getUsers());
    dispatch(getStates());
    dispatch(getBrands());
  }, [dispatch]);

  // Sync filteredData with curriculams when it changes
  useEffect(() => {
    setFilteredData(curriculams);
  }, [curriculams]);

  // Handle state change and filter VC data
  const handleStateChange = (value) => {
    const filteredVcData = vclistState.filter(
      (customer) => customer.state === value
    );
    setVcData(filteredVcData);
    form.setFieldsValue({ vc_name: undefined }); // Reset VC when state changes
  };

  // Search handler with proper filtering
  const handleSearch = (values) => {
    console.log("Form Values:", values);

    const filtered = curriculams.filter((curriculum) => {
      const matchesState = values.state_name
        ? curriculum.state_name === values.state_name
        : true;
      const matchesVC = values.vc_name
        ? curriculum.vc_name_id === values.vc_name ||
          curriculum.vc_name === values.vc_name
        : true;
      const matchesClass = values.class_name
        ? curriculum.class_name === values.class_name
        : true;

      return matchesState && matchesVC && matchesClass;
    });

    console.log("Filtered Curriculams:", filtered);
    setFilteredData(filtered);
  };

  // Clear filters and reset form
  const handleClear = () => {
    form.resetFields();
    setVcData([]);
    setFilteredData(curriculams); // Reset to full dataset
  };

  // Map dataSource for the table
  const dataSource = filteredData.map((curriculum, index) => ({
    key: index + 1,
    date: curriculum.Date || "N/A",
    holiday: curriculum.Holiday || "",
    unit: curriculum.Unit || "N/A",
    skills: curriculum["Employability Skills / Vocational Skills"] || "N/A",
    topic: curriculum.Topic || "N/A",
    subTopic: curriculum["Sub-Topic"] || "N/A",
  }));

  return (
    <div>
      <h3 className="mb-4 title">Curriculam</h3>
      <div
        style={{
          marginBottom: 16,
          backgroundColor: "#ffffff",
          border: "1px solid #eef2f6",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
        }}
      >
        <Form.Item>
          <Link to="/admin/add-curriculam">
            <Button type="primary" icon={<UploadOutlined />}>
              Upload Curriculam
            </Button>
          </Link>
        </Form.Item>

        <Form
          form={form}
          layout="inline"
          onFinish={handleSearch}
          initialValues={{
            state_name: "",
            vc_name: "",
            class_name: "",
          }}
        >
          <Form.Item name="state_name" label="State">
            <Select
              placeholder="Select State"
              onChange={handleStateChange}
              style={{ width: 200 }}
              allowClear
            >
              {statelistState.map((state) => (
                <Select.Option key={state.code} value={state.code}>
                  {state.state_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="vc_name" label="VC">
            <Select
              placeholder="Select VC"
              onChange={(value) => form.setFieldsValue({ vc_name: value })}
              style={{ width: 150 }}
              allowClear
              disabled={!vcData.length} // Disable if no VC data
            >
              {vcData
                .filter((item) => item.role === "vc")
                .map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item name="class_name" label="Class">
            <Select
              placeholder="Select Class"
              onChange={(value) => form.setFieldsValue({ class_name: value })}
              style={{ width: 150 }}
              allowClear
            >
              {classlistState.map((cls) => (
                <Select.Option key={cls._id} value={cls.title}>
                  {cls.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: 100 }}>
              Search
            </Button>
          </Form.Item>

          <Form.Item>
            <Button type="default" onClick={handleClear}>
              Clear
            </Button>
          </Form.Item>
        </Form>
      </div>

      <Table
        style={{ marginBottom: 16, padding: "20px", borderRadius: "8px" }}
        columns={columns}
        dataSource={dataSource}
        pagination={{ pageSize: 10 }} // Optional: Add pagination
      />
    </div>
  );
};

export default Curriculam;
